import type { ReleaseInfo } from "../@types/services/ReleaseInfo";
import { api } from "./api";

const API_BASE_URL = "/vbuyer/api/v2/release_infos";

interface ReleaseInfoFilter {
  id?: number;
  created_at?: string;
  release_date?: string;
  seen?: boolean;
}

interface FetchReleaseInfosParams {
  filters?: ReleaseInfoFilter;
}

interface ReleaseInfoResponse {
  total_items: number;
  results: ReleaseInfo[];
}

export const fetchReleaseInfos = async ({
  filters,
}: FetchReleaseInfosParams): Promise<ReleaseInfoResponse> => {
  const response = await api.get<ReleaseInfoResponse>("", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
    },
  });

  return response.data;
};

export const markNotYetSeenAsRead = async (): Promise<void> => {
  await api.patch<ReleaseInfoResponse>(
    "/mark_not_yet_seen_as_read",
    {},
    {
      baseURL: API_BASE_URL,
    },
  );
};
